// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".alpha-list-style[data-v-7baec505] {\n  list-style-type: upper-alpha;\n}\n.alpha-list-style li[data-v-7baec505] {\n  margin-top: 1rem;\n}\n.eula-body[data-v-7baec505] {\n  max-height: 500px;\n  overflow-y: scroll;\n  font-size: 12px;\n  text-align: left;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
